import querystring from 'querystring';
import sortKeys from '../object/sortKeys';

export default function parseSort(queryString, ...other) {
  const parsedQueryString = querystring.parse(queryString, ...other);

  return sortKeys(parsedQueryString);
}
